// extracted by mini-css-extract-plugin
export default {"paper":"style_paper__+ycWx"};